module.exports = {
  messages: {
    BUTTON_SHOW_MORE: 'Mehr',
    JOBS_MATCHING_REASONS_ERROR:
      'Die KI konnte die Details der Stellen-Beschreibung, die zu Deiner Suche passen, leider nicht laden.',
    JOBS_MATCHING_REASONS_LOADING:
      'Suche passende Details in der Job-Beschreibung',
    JOBS_MATCHING_REASONS_TIP_HEADLINE: 'Erkenne sofort, warum ein Job passt',
    JOBS_MATCHING_REASONS_TIP_SUBTITLE: 'KI-Funktion im Beta-Stadium',
    JOBS_SALARY_XING_ESTIMATED: '(von XING geschätzt)',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO: 'Vor 30+ Tagen',
    JOBS_TIMESTAMP_JUST_NOW: 'Gerade eben',
    JOBS_TIMESTAMP_N_DAYS_AGO: 'Vor {number} Tagen',
    JOBS_TIMESTAMP_N_HOURS_AGO:
      '{number, plural, =1 {Vor 1 Stunde} other {Vor # Stunden}}',
    JOBS_TIMESTAMP_YESTERDAY: 'Gestern',
  },
};
